import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import utils from 'bxl-utils'

export default function useLocationSearch<
  T extends Record<string, string> = Record<string, string>
>(): Partial<T> {
  const location = useLocation()
  return useMemo(() => {
    return utils.uri.parse(location.search) as Partial<T>
  }, [location])
}
